import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorWebhookSignal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m12.757 6.937 2.355-2.354a.778.778 0 0 0 0-1.1l-2.355-2.355a.778.778 0 1 0-1.1 1.1l1.027 1.026h-7.91A3.475 3.475 0 0 0 1.3 6.73v1.882a.778.778 0 1 0 1.556 0V6.729c0-1.06.859-1.919 1.919-1.919h7.91l-1.028 1.027a.778.778 0 1 0 1.1 1.1ZM11.216 21.14l1.027 1.027a.778.778 0 0 1-1.1 1.1l-2.355-2.355a.778.778 0 0 1 0-1.1l2.355-2.355a.778.778 0 1 1 1.1 1.1l-1.027 1.027h7.91c1.06 0 1.918-.859 1.918-1.918v-1.882a.778.778 0 0 1 1.556 0v1.882a3.475 3.475 0 0 1-3.475 3.474h-7.909Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.282 8.092H4.899v3.546h2.837v4.965h3.546v-8.51ZM14.26 11.638a1.773 1.773 0 1 0 0-3.546 1.773 1.773 0 0 0 0 3.546ZM21.494 8.092h-3.546l-3.546 8.51h3.546l3.546-8.51Z"
    />
  </svg>
);
export default SvgTwoColorWebhookSignal;
